import type { NotificationResponseSourceSourceUserAllOf } from './notificationResponseSourceSourceUserAllOf';
import type { NotificationResponseSourceSourceUserAllOfTwo } from './notificationResponseSourceSourceUserAllOfTwo';

/**
 * 알림을 발생시킨 사용자 정보
 */
export type NotificationResponseSourceSourceUser = NotificationResponseSourceSourceUserAllOf & NotificationResponseSourceSourceUserAllOfTwo;
